<div class="error-message" *ngIf="!isFormArray && getError()" [style.top.px]="top" [style.left.px]="left">
	{{ message || getError() }}
</div>
<div class="error-message" *ngIf="isFormArray && getFormErrors()" [style.top.px]="top" [style.left.px]="left">
	{{ message || getFormErrors() }}
</div>
